import { cn } from '@/lib/cn'

export type ButtonVariant = 'primary' | 'secondary' | 'ghost'
export type ButtonSize = 'sm' | 'md' | 'lg'

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-volt text-volt-ink hover:bg-volt-soft shadow-[0_8px_24px_-12px_var(--color-volt)]',
  secondary: 'bg-white/[0.07] text-fg ring-1 ring-inset ring-line-strong hover:bg-white/[0.12]',
  ghost: 'text-fg-muted hover:bg-white/[0.06] hover:text-fg',
}

const sizes: Record<ButtonSize, string> = {
  sm: 'h-9 gap-1.5 px-3.5 text-sm',
  md: 'h-11 gap-2 px-5 text-[0.9375rem]',
  lg: 'h-12 gap-2.5 px-6 text-base',
}

/** Shared button styling, also applied to router links that look like buttons. */
export function buttonStyles({ variant = 'primary', size = 'md' }: { variant?: ButtonVariant; size?: ButtonSize } = {}) {
  return cn(
    'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold whitespace-nowrap',
    'transition-[background-color,color,transform,box-shadow] duration-200 active:scale-[0.97]',
    'disabled:pointer-events-none disabled:opacity-50',
    variants[variant],
    sizes[size],
  )
}
